import React from 'react';
import styled from 'styled-components';
import { ClickableElement, Box } from '@cko/primitives';
import { IconActionDelete } from '@cko/icons';
const IconButton = styled(ClickableElement) `
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;
const DeleteButton = ({ name, onDelete }) => (React.createElement(Box, { ml: "var(--layout-spoon)" },
    React.createElement(IconButton, { "aria-label": name, onClick: onDelete, "data-testid": "delete-row-icon" },
        React.createElement(IconActionDelete, null))));
export default DeleteButton;
